/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Case } from '../../models/case';

export interface GetCase$Params {

/**
 * Id of a resource.
 */
  id: string;

/**
 * include associations in the response. defaults to false
 */
  include_associations?: boolean;
}

export function getCase(http: HttpClient, rootUrl: string, params: GetCase$Params, context?: HttpContext): Observable<StrictHttpResponse<Case>> {
  const rb = new RequestBuilder(rootUrl, getCase.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.query('include_associations', params.include_associations, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Case>;
    })
  );
}

getCase.PATH = '/api/v1/cases/{id}';
